export const state = () => ({
	invoices: {},
})

export const actions = {
	async list({ commit }, { companyId }) {
		return await useNuxtApp()
			.$api(`/api/company/${companyId}/invoices/`)
			.then((res) => {
				commit('setInvoices', { data: res })
				return res
			})
			.catch((err) => {
				throw err
			})
	},
}

export const mutations = {
	setInvoices(state, { data }) {
		state.invoices = data
	},
}
